import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNU = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 11.958v8.432l-8.696-8.432H25ZM13.044 25.002h7.345l-7.345-9.783-1.087 7.609 1.087 2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M24.932 24.999H25v-.067l-.067.067Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 13.043V0h-.004C11.19.002 0 11.194 0 25h13.043v-7.345L20.389 25h4.545l.067-.067V20.39l-7.345-7.345H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m25.001 21.927-8.882-8.882h-3.074L25 25.001v-3.074Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M12.649 3.262A25.056 25.056 0 0 0 9.884 5.09h1.025L8.2 7.06l1.035 3.187-2.712-1.97-.288.21a25.077 25.077 0 0 0-2.972 4.162V25h6.521V9.784h15.218V3.262H12.649Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M10.679 4.506c-.27.189-.536.383-.797.582l-1.686 1.97-1.675 1.218-.291.211a25.116 25.116 0 0 0-1.724 2.192 4.62 4.62 0 0 0 6.173-6.173Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m6.231 8.487.291-.211 2.711 1.97-1.035-3.188 2.71-1.97H9.884A25.158 25.158 0 0 0 6.23 8.487ZM17.279 4.347l.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.746l.54-1.66ZM6.522 15.217l.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.66-1.413-1.027h1.746l.54-1.661Z"
}));
FlagNU.displayName = 'FlagNU';
export default withFlagWrapper(FlagNU);
//# sourceMappingURL=index.js.map